// extracted by mini-css-extract-plugin
export var circle = "_ds-1";
export var exitConfirmationModal = "_ds-5";
export var iframe = "_ds-0";
export var offline = "_ds-3";
export var online = "_ds-2";
export var workstationSelectError = "_ds-4";